import React, { useCallback, useEffect } from 'react'
import type { Track } from 'types/track'
import mixpanel from '@disco/api/mixpanel'
import Row from 'components/common/row'
import TrackInfo from 'components/common/track-info'
import { Tab, Tabs } from 'components/ui'
import CopyUrlItem from 'components/ui/copy-url-item'
import Heading from 'components/ui/heading'
import { HoverProvider } from 'components/ui/hover-provider'
import ModalWindow from 'components/ui/modal-window'
type Props = {
  onClose: (...args: Array<any>) => any
  track: Track
}

const AggregatedTrackShare = ({
  track,
  onClose,
}: Props): null | React.ReactNode => {
  let playUrl = ''

  if (track?.origin?.source_library?.url) {
    playUrl = `${track.origin.source_library.url}/track/${track.id}`
  }

  const onPlayUrlCopy = useCallback(() => {
    mixpanel.sendPureEvent('Copy track url', {
      Url: playUrl,
      // Properties for event #7 from https://disco-team.atlassian.net/browse/DISCO-5985
      Modal: 'Share Track',
      'Track ID': track.id,
      Context: 'Aggregated search',
      Catalog: track.origin?.source_library?.id,
      'Catalog Business': track.origin?.business?.id,
    })
  }, [playUrl])
  useEffect(() => {
    if (track) {
      // Properties for event #5 from https://disco-team.atlassian.net/browse/DISCO-5985
      mixpanel.sendPureEvent('Open modal', {
        Modal: 'Share Track',
        'Track ID': track.id,
        Context: 'Aggregated search',
        Catalog: track.origin?.source_library?.id,
        'Catalog Business': track.origin?.business?.id,
      })
    }
  }, [])
  if (!track) return null
  return (
    <ModalWindow
      header={
        <>
          <Heading size="700">Share Track</Heading>
          <HoverProvider>
            <TrackInfo location="explorer" track={track} />
          </HoverProvider>
        </>
      }
      isOpen
      width="medium"
      onClose={onClose}
    >
      <Tabs className="Tabs--modal" index={0}>
        <Tab label="Copy URL">
          <Row columnsSize={[12]} marginBottom="small">
            <div>
              <CopyUrlItem
                label="Track URL"
                url={playUrl}
                onCopy={onPlayUrlCopy}
              />
            </div>
          </Row>
        </Tab>
      </Tabs>
    </ModalWindow>
  )
}

export default AggregatedTrackShare
